import React from 'react'
import { Card } from 'react-bootstrap'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import moment from 'moment'

export function DetalleCamionesEnPlayaView (props) {
  const { detalle, handleClose } = props

  console.log('detalle ', detalle)

  return (
    <>
      <Card style={{ border: 'none' }}>
        <Card.Header>
          <h3 style={{ textAlign: 'center' }}>Detalles de CTG</h3>
          <IconButton onClick={handleClose} style={{ position: 'absolute', top: 0, right: 0, padding: '15px' }} > <CloseIcon /> </IconButton>
        </Card.Header>
        <br />
        <Card.Body style={{ marginLeft: '5%' }}>
          {detalle.numero && <h6>Número : <span style={{ fontWeight: 'bold' }}> {detalle.numero} </span></h6> }
          {detalle.fechaDeIngreso && <h6>Fecha de ingreso : <span style={{ fontWeight: 'bold' }}> {moment(detalle.fechaDeIngreso).format('DD/MM/YYYY HH:mm')} </span></h6> }
          {detalle.cereal && <h6>Cereal : <span style={{ fontWeight: 'bold' }}> {detalle.cereal} </span></h6> }
          {detalle.cerealVariedad && <h6>Cereal variedad : <span style={{ fontWeight: 'bold' }}> {detalle.cerealVariedad} </span></h6> }
          <hr />
          {detalle.exportador && <h6>Exportador : <span style={{ fontWeight: 'bold' }}> {detalle.exportador} </span></h6> }
          {detalle.titularDeCupo && <h6>Titular de cupo : <span style={{ fontWeight: 'bold' }}> {detalle.titularDeCupo} </span></h6> }
          {detalle.corredorVendedor && <h6>Corredor Vendedor: <span style={{ fontWeight: 'bold' }}> {detalle.corredorVendedor} </span></h6> }
          <hr />
          {detalle.vendedor && <h6>Entregador: <span style={{ fontWeight: 'bold' }}> {detalle.vendedor} </span></h6> }
          {detalle.camion && <h6>Camión : <span style={{ fontWeight: 'bold' }}> {detalle.camion} </span></h6> }
          {detalle.acoplado && <h6>Acoplado : <span style={{ fontWeight: 'bold' }}> {detalle.acoplado} </span></h6> }
          {detalle.pesoNeto && <h6>Peso Neto : <span style={{ fontWeight: 'bold' }}> {detalle.pesoNeto} kgs. </span></h6> }
          {detalle.estadoCTG && <h6>Estado de CTG : <span style={{ fontWeight: 'bold' }}> {detalle.estadoCTG} </span></h6> }
          {detalle.turnoDeSalida && <h6>Turno de salida : <span style={{ fontWeight: 'bold' }}> {detalle.turnoDeSalida} </span></h6> }
          {detalle.codigoCupo && <h6>Código de cupo : <span style={{ fontWeight: 'bold' }}> {detalle.codigoCupo} </span></h6> }
        </Card.Body>

      </Card>
    </>
  )
}
